import { atom } from "jotai";

/**
 * Atom to track the currently visible/active chat session ID.
 * This is used to determine whether to send notifications when a chat completes -
 * if the user has navigated away from the conversation (even within the same tab),
 * we should still notify them.
 */
export const activeChatSessionIdAtom = atom<string | null>(null);

/**
 * Represents a completed response that may need a notification.
 */
export interface CompletedResponse {
  sessionId: string;
  messageId: string;
  /** Number of times notification has been retried (defaults to 0) */
  retryCount?: number;
}

/**
 * Atom for completed responses that need notification.
 * The notification listener component will consume these and send browser notifications.
 * Each entry represents a single response (not a session), allowing multiple notifications per session.
 */
export const completedResponsesAtom = atom<CompletedResponse[]>([]);
